import {Color} from '~/constants/style';

export const titleStyle = {
  fontWeight: 600,
  color: Color.Purple600,
  fontSize: '18px',
};

export const cardContentStyle = {
  p: 1,
  mb: 5,
};

export const companyItemStyle = {
  display: 'flex',
  alignItems: 'center',
  mb: 1,
};

export const rankStyle = {
  mr: 1.5,
  color: Color.PrimaryMain,
  fontWeight: 700,
  fontSize: '30px',
};

export const companyNameStyle = {
  fontSize: '14px',
  color: Color.Grey500,
  fontWeight: 400,
};

export const claimsInfoStyle = {
  color: Color.Purple600,
  fontWeight: 600,
  fontSize: '14px',
};

export const lastCompanyItemStyle = {
  display: 'flex',
  alignItems: 'center',
  mb: 0,
};
